"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var lodash_1 = require("lodash");
var useSizeElement = function (resolution) {
    var elementRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(0), width = _a[0], setWidth = _a[1];
    (0, react_1.useEffect)(function () {
        var elements = (elementRef.current &&
            elementRef.current.parentNode &&
            elementRef.current.parentNode.children) ||
            [];
        if (elements && elements.length !== 0) {
            setWidth((0, lodash_1.reduce)(elements, function (sum, n) {
                return sum + n.clientWidth;
            }, 0));
        }
    }, [elementRef.current, resolution]);
    return { width: width, elementRef: elementRef };
};
exports.default = useSizeElement;
